export default __webpack_public_path__ + "static/media/painscale_4.d17ecee7.png";